export default __webpack_public_path__ + "static/media/sandrine-324.b0a3694b.jpg";